import React from 'react';
import LogoIcon from 'assets/images/logo-icon.svg';
import Glasses from 'assets/images/glasses.png';

const UnifiedWishlist = ({ animationCount }) => {
  return (
    <div
      className={`position-relative flex-fill d-md-block home-glasses with-hover ${
        animationCount ? `anim-${animationCount}` : ''
      }`}
    >
      <img src={Glasses} alt='Glasses' />
      <img src={LogoIcon} alt='Logo Icon' className='img-logo img-logo-1' />
      <img src={LogoIcon} alt='Logo Icon' className='img-logo img-logo-2' />
      <img src={LogoIcon} alt='Logo Icon' className='img-logo img-logo-3' />
    </div>
  );
};

export default UnifiedWishlist;
